// src/components/audition-booking-wizard/Step5_ApplicationDetails.jsx
import React from 'react';
import { Button, Row, Col, Spinner, Alert, Badge, Form, ProgressBar } from 'react-bootstrap'; // ADDED ProgressBar
import { FaStar, FaVideo } from 'react-icons/fa';
import VideoPlayModal from './VideoPlayModal'; 
import { JOGET_BASE_URL } from './utils/bookingHelpers'; 
const BASE_URL = process.env.REACT_APP_API_URL.replace("/api", "");


const Step5_ApplicationDetails = ({
    loadingDetails, auditionDetails, apiError, applicationJogetId,
    showVideoModal, setShowVideoModal, activeVideoUrl, setActiveVideoUrl,
    selectedVideoFileForReupload, reuploadingVideo, reuploadProgress, reuploadError, reuploadFileInputRef,
    handleReuploadFileChange, handleReuploadButtonClick,showFeedbackModal,setShowFeedbackModal,directorId,roleId,mysqlApplicationId
}) => {
    if (loadingDetails) {
        return (
            <div className="text-center p-5">
                <Spinner className="text-white" animation="border" variant="danger" />
                <p className='text-white mt-3'>Loading audition details...</p>
            </div>
        );
    }

    if (!auditionDetails) {
        return <Alert variant="warning" className="m-3">No audition details found.</Alert>;
    }
    console.log("AUDITION DETAILS:", auditionDetails);
    if (apiError) return <Alert variant="danger" className="m-3">{apiError}</Alert>;


    const resultStatus = auditionDetails?.result || "PENDING";
    const isFinalStatus = resultStatus === "SELECTED" || resultStatus === "REJECTED";
    const isResubmitRequest = resultStatus === "RESUBMIT" && auditionDetails?.bookingType === "VIDEO_UPLOAD";

    return (
        <div className="application-dashboard animate-fade-in text-start">
            
            {/* STATUS ALERTS */}
            {isFinalStatus && (
                <Alert variant={resultStatus === "SELECTED" ? "success" : "danger"} className="text-center fw-bold border-0 rounded-3">
                    Your application has been {resultStatus}!
                </Alert>
            )}

            <Row className="g-4 mt-2">
                {/* LEFT COLUMN: Application Details (Styled like your image) */}
                <Col lg={4}>
                    <div className="h-100 p-4 rounded-4" style={{ backgroundColor: '#111111', border: '1px solid #222' }}>
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom border-dark pb-3">
                            <h5 className="text-white mb-0 fw-bold">Overview</h5>
                            <Badge bg={
                                resultStatus === 'SELECTED' ? 'success' : 
                                resultStatus === 'REJECTED' ? 'danger' : 
                                resultStatus === 'RESUBMIT' ? 'warning' : 'secondary'
                            } className="px-3 py-2 rounded-pill">
                                {resultStatus}
                            </Badge>
                        </div>

                        <div className="d-flex justify-content-between align-items-center pb-1">
                            <label className="text-muted small fw-bold text-uppercase tracking-wider mb-1" style={{ fontSize: '11px', letterSpacing: '1px' }}>Application ID:</label>
                            <div className="text-white fw-bold fs-6">{auditionDetails.applicationId}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center pb-1">
                            <label className="text-muted small fw-bold text-uppercase tracking-wider mb-1" style={{ fontSize: '11px', letterSpacing: '1px' }}>Role</label>
                            {/* <div className="text-white fw-bold fs-6">{auditionDetails.roleName}</div> */}
                            <div className="role-title-custom"> {auditionDetails.roleName}</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center pb-1">
                            <label className="text-muted small fw-bold text-uppercase tracking-wider mb-1" style={{ fontSize: '11px', letterSpacing: '1px' }}>Audition Mode</label>
                            <div className="text-white fw-bold fs-6">{auditionDetails.bookingType}</div>
                        </div>

                        {/* {
    auditionDetails?.bookingType === "ONLINE_MEETING" &&
    auditionDetails?.meetingLink &&
    new Date() <= new Date(auditionDetails.meetingEnd) && (

        <div className="mt-3 text-center">

            <Button
                variant="success"
                href={auditionDetails.meetingLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-100"
            >
                🎥 Join Meeting
            </Button>

            {
                auditionDetails?.meetingStart && (
                    <small className="text-muted d-block mt-2">
                        Meeting Time :
                        {" "}
                        {new Date(
                            auditionDetails.meetingStart
                        ).toLocaleString()}
                    </small>
                )
            }

        </div>
    )
} */}
                        {
    auditionDetails?.bookingType === "ONLINE_MEETING" &&
    auditionDetails?.meetingLink && (
        <div className="mt-3 text-center">

            <Button
                variant="success"
                href={auditionDetails.meetingLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-100"
            >
                🎥 Join Meeting
            </Button>

            {
                auditionDetails?.meetingStart && (
                    <small className="text-muted d-block mt-2">
                        Meeting Time :
                        {" "}
                        {new Date(
                            auditionDetails.meetingStart
                        ).toLocaleString()}
                    </small>
                )
            }

        </div>
    )
}
                        {/* Director's Feedback */}
                        {/* {(auditionDetails.review || auditionDetails.ratingStar > 0) && (
                            <div className="mt-2 p-1 rounded bg-dark border border-secondary">
                                <label className="text-warning small fw-bold text-uppercase tracking-wider mb-2">🎬 Feedback</label>
                                <p className="text-light small mb-2">{auditionDetails.review || "No written review."}</p>
                                {auditionDetails.ratingStar > 0 && (
                                    <div className="text-warning">
                                        {[...Array(5)].map((_, i) => (
                                            <FaStar key={i} className={i < auditionDetails.ratingStar ? "active" : "text-secondary"} />
                                        ))}
                                    </div>
                                )}
                            </div>
                        )} */}

                        {(auditionDetails.review || auditionDetails.modified_by_admin || auditionDetails.ratingStar > 0) && (
                            <div className="mt-2 p-1 rounded bg-dark border border-secondary">

                                <label className="text-warning small fw-bold text-uppercase tracking-wider mb-2">
                                🎬 Feedback
                                </label>

                                {/* ✅ FIXED LOGIC */}
                                {auditionDetails.modified_by_admin ? (
                                <p className="text-warning small mb-2">
                                    🛠 Admin: {auditionDetails.modified_by_admin}
                                </p>
                                ) : (
                                <p className="text-light small mb-2">
                                    🎬 Director: {auditionDetails.review || "No written review."}
                                </p>
                                )}

                                {auditionDetails.ratingStar > 0 && (
                                <div className="text-warning">
                                    {[...Array(5)].map((_, i) => (
                                    <FaStar
                                        key={i}
                                        className={i < auditionDetails.ratingStar ? "active" : "text-secondary"}
                                    />
                                    ))}
                                </div>
                                )}

                            </div>
                        )}

                        {/* {(auditionDetails.review || auditionDetails.modified_by_admin || auditionDetails.ratingStar > 0) && (
                            <div className="mt-2 p-1 rounded bg-dark border border-secondary">

                                <label className="text-warning small fw-bold text-uppercase tracking-wider mb-2">
                                🎬 Feedback
                                </label>

                                {auditionDetails.modified_by_admin && (
                                <p className="text-warning small mb-1">
                                    🛠 Admin: {auditionDetails.modified_by_admin}
                                </p>
                                )}

                                <p className="text-light small mb-2">
                                🎬 Director: {auditionDetails.review || "No written review."}
                                </p>

                                {auditionDetails.ratingStar > 0 && (
                                <div className="text-warning">
                                    {[...Array(5)].map((_, i) => (
                                    <FaStar
                                        key={i}
                                        className={i < auditionDetails.ratingStar ? "active" : "text-secondary"}
                                    />
                                    ))}
                                </div>
                                )}

                            </div>
                        )} */}

                        {/* {
                            resultStatus === "SELECTED" && (

                                <div className="mt-4 text-center">

                                    <Button
                                        className="casting-review-btn"
                                        onClick={() =>
                                            setShowFeedbackModal(true)
                                        }
                                    >

                                        Review Comment

                                    </Button>

                                </div>

                            )
                        } */}
                        { resultStatus === "SELECTED" && (
                                <div className="mt-4 p-3 rounded bg-dark border border-secondary">
                                    <label className="text-info small fw-bold text-uppercase tracking-wider mb-2">
                                        Your Feedback
                                    </label>
                                    <p className="text-light small mb-3">
                                        {
                                            auditionDetails?.candidateFeedbackReview
                                            || "No feedback submitted yet."
                                        }
                                    </p>
                                    {
                                        auditionDetails?.candidateFeedbackRating > 0 && (
                                            <div className="text-warning">
                                                {
                                                    [...Array(5)].map((_, i) => (
                                                        <FaStar
                                                            key={i}
                                                            className={
                                                                i < auditionDetails.candidateFeedbackRating
                                                                ? "active"
                                                                : "text-secondary"
                                                            }
                                                        />
                                                    ))
                                                }
                                            </div>
                                        )
                                    }
                                    {
                                        !auditionDetails?.candidateFeedbackReview && (
                                            <div className="text-center mt-3">
                                                <Button
                                                    className="casting-review-btn"
                                                    onClick={() =>
                                                        setShowFeedbackModal(true)
                                                    }
                                                >
                                                    Give Feedback
                                                </Button>
                                            </div>
                                        )
                                    }

                                </div>

                            )
                        }

                        {/* Resubmit Prompt */}
                        {isResubmitRequest && (
                            <div className="mt-4 p-4 rounded bg-danger bg-opacity-10 border border-danger text-center">
                                <h6 className="text-danger fw-bold">Re-Upload Requested</h6>
                                <p className="text-light small mb-3">The director requested a revised performance.</p>
                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-white-50">Upload New Video</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="video/mp4,video/quicktime"
                                        onChange={handleReuploadFileChange}
                                        ref={reuploadFileInputRef}
                                        disabled={reuploadingVideo}
                                    />
                                </Form.Group>
                                {selectedVideoFileForReupload && !reuploadingVideo && (
                                    <Button variant="danger" size="sm" onClick={handleReuploadButtonClick} disabled={reuploadingVideo}>
                                        {reuploadingVideo ? <Spinner className="text-white" animation="border" size="sm" /> : 'Re-upload Video'}
                                    </Button>
                                )}
                                {reuploadingVideo && (
                                    <>
                                        <div className="mb-1 text-light small">Uploading...</div>
                                        <ProgressBar animated now={reuploadProgress} label={`${reuploadProgress}%`} className="mb-3" />
                                    </>
                                )}
                                {reuploadError && <Alert variant="danger" className="mt-2 py-2">{reuploadError}</Alert>}
                            </div>
                        )}
                    </div>
                </Col>

                {/* RIGHT COLUMN: Media History / Grid */}
                <Col lg={8}>
                    <div className="h-100 p-4 rounded-4" style={{ backgroundColor: '#111111', border: '1px solid #222' }}>
                        <h5 className="text-white mb-4 fw-bold border-bottom border-dark pb-3">Media History</h5>

                        <div className="d-flex flex-wrap gap-4">
                            {auditionDetails.videoHistory && auditionDetails.videoHistory.length > 0 ? (
                                auditionDetails.videoHistory.map((vid, index) => (
                                    <div 
                                        key={vid.id}
                                        className="media-grid-item position-relative rounded-4 overflow-hidden"
                                        style={{ 
                                            width: '200px', 
                                            height: '280px', 
                                            backgroundColor: '#000', 
                                            border: '1px solid #333',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => {
                                            setActiveVideoUrl(vid.video_url); 
                                            setShowVideoModal(true);
                                        }}
                                    >
                                        <Badge bg="danger" className="position-absolute top-0 start-0 m-2" style={{ zIndex: 3 }}>
                                            Ver {auditionDetails.videoHistory.length - index}
                                        </Badge>

                                        <div className="position-absolute w-100 h-100 d-flex flex-column align-items-center justify-content-center" style={{ zIndex: 2, background: 'rgba(0,0,0,0.5)' }}>
                                            <FaVideo className="text-white" size={24} />
                                            <span className="text-white mt-2 small fw-bold">Play Submission</span>
                                        </div>

                                          <video
                                                // src={`${BASE_URL}/uploads/${vid.video_url}`}
                                                src={vid.video_url}
                                                className="w-100 h-100 object-fit-cover opacity-50"
                                            />

                                        {/* <video
                                            src={`${JOGET_BASE_URL}/jw/web/client/app/bookmyaudition/form/download/roleApplication/${auditionDetails.jogetApplicationId}/${vid.video_url}`}
                                            className="w-100 h-100 object-fit-cover opacity-50"
                                        /> */}
                                    </div>
                                ))
                            ) : (
                                <div className="text-center w-100 py-5 text-white border border-dashed rounded-4">
                                    No videos found in history.
                                </div>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            <VideoPlayModal
                show={showVideoModal}
                handleClose={() => setShowVideoModal(false)}
                videoUrl={activeVideoUrl}
                jogetApplicationId={applicationJogetId}
            />
        </div>
    );
};

export default Step5_ApplicationDetails;